export default __webpack_public_path__ + "71bf5d45e86dce1d447580d0a2ca8a06.png";